import * as React from 'react';
import MemberCardComponent from 'src/modules/our-team/index/partials/MemberCard.component';
import teamMembers from 'src/modules/our-team/teamMembers';
import boardMembers from 'src/modules/our-team/boardMembers';

const OurTeamComponent: React.StatelessComponent = () => (
  <section className="team-section">
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-8">
          <h1 className="bold-title">
            Nuestro equipo
          </h1>
          <div className="gap-20"/>
        </div>
        <div className="col-sm-12 col-md-4">
          <p className="breadcrumb text-right">
            Inicio > Nuestro equipo
          </p>
        </div>
      </div>
      <div className="gap-20"/>

      <div className="row row-eq-height padding-l-r-60">
        {teamMembers.map(member => (
          <div
            className="item col-sm-6 col-md-4"
            key={member.name}
          >
            <MemberCardComponent
              imagePath={member.imagePath}
              profilePath={member.profilePath}
              linkedinPath={member.linkedinPath}
              name={member.name}
              title={member.title}
              description={member.shortDescription}
            />
            <div className="gap-20"/>
          </div>
        ))}
      </div>
    </div>
    <div className="gap-50"/>
    <div className="partners">
      <div className="container">
        <div className="gap-10"/>
        <h3 className="text-center bold-subtitle">Socios de The Crowd Angel</h3>
        <div className="gap-10"/>
        <div className="row row-eq-height padding-l-r-60">
          {boardMembers.map(member => (
            <div
              className="item col-sm-6 col-md-4"
              key={member.name}
            >
              <MemberCardComponent
                imagePath={member.imagePath}
                linkedinPath={member.linkedinPath}
                name={member.name}
                title={member.title}
                description={member.shortDescription}
              />
              <div className="gap-20"/>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="gap-50"/>
    <div className="container">
      <div className="row">
        <div className="col-md-4 text-center">
          <div className="inveready pointer"/>
        </div>
        <div className="col-md-4 text-center">
          <div className="keyword pointer"/>
        </div>
        <div className="col-md-4 text-center">
          <div className="sevenzonic pointer"/>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-sm-offset-4">
          <hr/>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 text-center">
          <h2 className="f-s-22">
            Nuestro Partner Legal
          </h2>
          <div className="gap-20"/>
          <div className="rousaud pointer"/>
        </div>
      </div>
    </div>
  </section>
);

export default OurTeamComponent;


// WEBPACK FOOTER //
// ./src/modules/our-team/index/OurTeam.component.tsx